"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnFlights = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../../utils/classFunctions");
const DateTime_1 = require("../../../../../DateTime");
const Icon_1 = require("../../../../../Icon");
const MultiLanguage_1 = require("../../../../../MultiLanguage");
const Tooltip_1 = require("../../../../../Tooltip");
require("./index.scss");
const className = 'flight-passenger-list-flights';
const airportName = (airport) => {
    return airport.name
        ? (react_1.default.createElement(MultiLanguage_1.MultiLanguage, { value: airport.name }))
        : airport.code;
};
const TooltipText = (flight) => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("span", { className: `${className}__flight-info` },
            flight.number,
            ", ",
            airportName(flight.origin),
            " - ",
            airportName(flight.destination)),
        react_1.default.createElement("span", { className: `${className}__flight-departure` }, flight.departure && (react_1.default.createElement(DateTime_1.DateTime, { value: flight.departure, isLocalTime: true })))));
};
const ColumnFlights = (props) => {
    const { flight } = props !== null && props !== void 0 ? props : {};
    return {
        id: 'flights',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Flights:Title', defaultMessage: 'Flights' })),
        Cell: ({ row }) => {
            const flightId = flight.id;
            const outboundFlight = row.original.reservation.flights.outbound;
            const returnFlight = row.original.reservation.flights.return;
            const outboundModificators = outboundFlight.id === flightId ? ['active'] : [];
            const returnModificators = returnFlight && (returnFlight === null || returnFlight === void 0 ? void 0 : returnFlight.id) === flightId ? ['active'] : [];
            return (react_1.default.createElement("div", { className: className },
                outboundFlight && (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${className}__outbound`, outboundModificators) },
                    react_1.default.createElement(Tooltip_1.Tooltip, { modificators: 'white', text: react_1.default.createElement(TooltipText, { ...outboundFlight }) },
                        react_1.default.createElement(Icon_1.Icon, { name: 'airplane' })))),
                returnFlight && (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${className}__return`, returnModificators) },
                    react_1.default.createElement(Tooltip_1.Tooltip, { modificators: 'white', text: react_1.default.createElement(TooltipText, { ...returnFlight }) },
                        react_1.default.createElement(Icon_1.Icon, { name: 'airplane' }))))));
        },
    };
};
exports.ColumnFlights = ColumnFlights;
//# sourceMappingURL=index.js.map